<div class="p-grid">
  <div class="p-col-12">
    <div class="card">
      <div class="p-d-flex p-jc-between">
        <h4>General</h4>
        <a routerLink="/needs-attention" class="bold">
          View Items Needing Attention
        </a>
      </div>
    </div>
  </div>
  <div class="p-col-12 p-md-6">
    <div class="card">
      <div class="header-with-button">
        <h5 data-cy="office-card-header">Office</h5>
        <!-- todo: add restriction checking  -->
        <div *hasPermission="['config.set']">
          <button
            *ngIf="!franchiseInfo.editMode"
            pButton
            icon="pi pi-pencil"
            (click)="franchiseInfo.editMode = true"
          ></button>
          <button
            *ngIf="franchiseInfo.editMode"
            class="p-button-success"
            pButton
            icon="pi pi-save"
            (click)="saveInfo('franchise-info', franchiseInfo)"
          ></button>
        </div>
      </div>

      <p *ngFor="let item of franchiseInfo | keyvalue; trackBy: identify">
        <span *ngIf="item.key !== 'editMode'">
          <span *ngIf="configsLoaded; else elseBlock">
            {{ item.key | prettyProperty }}:
            <span
              *ngIf="!franchiseInfo.editMode"
              [class.placeholder-text]="!item.value"
              >{{ item.value | notSet }}</span
            >
            <span *ngIf="franchiseInfo.editMode">
              <br /><input
                type="text"
                name="item.key"
                (change)="markAsModified(item.key)"
                [(ngModel)]="franchiseInfo[item.key]"
                pInputText
            /></span>
          </span>
        </span>
      </p>
      <p>
        <span>
          <span [formGroup]="locationForm">
            <span *ngIf="!franchiseInfo.editMode"
              >HQ Location: {{ locationForm.value.location || 'Not Set' }}</span
            >
            <span [hidden]="!franchiseInfo.editMode">
              <div>
                HQ Location:
                <input
                  *ngIf="googleHelper.loaded | async"
                  class="location-input"
                  [options]="options"
                  pInputText
                  formControlName="location"
                  ngx-gp-autocomplete
                  (onAddressChange)="handleAddressChange($event)"
                  #googleAutocomplete="ngx-places"
                />
              </div>
            </span>
          </span>
        </span>
      </p>
    </div>
  </div>
  <div class="p-col-12 p-md-6">
    <div class="card">
      <div class="header-with-button">
        <h5>System</h5>
        <div *hasPermission="['config.set']">
          <button
            *ngIf="!systemDetails.editMode"
            pButton
            icon="pi pi-pencil"
            (click)="systemDetails.editMode = true"
          ></button>
          <button
            *ngIf="systemDetails.editMode"
            class="p-button-success"
            pButton
            icon="pi pi-save"
            (click)="saveInfo('system-details', systemDetails)"
          ></button>
        </div>
      </div>
      <p *ngFor="let item of systemDetails | keyvalue; trackBy: identify">
        <span *ngIf="item.key !== 'editMode'">
          <span *ngIf="configsLoaded; else elseBlock">
            {{ item.key | prettyProperty }}:
            <span
              *ngIf="!systemDetails.editMode"
              [class.placeholder-text]="!item.value"
              >{{ item.value | notSet }}</span
            >
            <span *ngIf="systemDetails.editMode">
              <br /><input
                type="text"
                name="item.key"
                (change)="markAsModified(item.key)"
                [(ngModel)]="systemDetails[item.key]"
                pInputText
            /></span>
          </span>
        </span>
      </p>
    </div>
  </div>
  <div class="p-col-12 p-md-6">
    <div class="card">
      <div class="header-with-button">
        <h5>Legal</h5>
        <div *hasPermission="['config.set']">
          <button
            *ngIf="!legalCard.editMode"
            pButton
            icon="pi pi-pencil"
            (click)="legalCard.editMode = true"
          ></button>
          <button
            *ngIf="legalCard.editMode"
            class="p-button-success"
            pButton
            icon="pi pi-save"
            (click)="saveInfo('legal', legalCard)"
          ></button>
        </div>
      </div>
      <p *ngFor="let item of legalCard | keyvalue; trackBy: identify">
        <span *ngIf="item.key !== 'editMode'">
          <span *ngIf="configsLoaded; else elseBlock">
            {{ item.key | prettyProperty }}:
            <span
              *ngIf="!legalCard.editMode"
              [class.placeholder-text]="!item.value"
              >{{ item.value | notSet }}</span
            >
            <span *ngIf="legalCard.editMode"
              ><br /><input
                type="text"
                name="item.key"
                (change)="markAsModified(item.key)"
                [(ngModel)]="legalCard[item.key]"
                pInputText
            /></span>
          </span>
        </span>
      </p>
    </div>
  </div>
  <div class="p-col-12 p-md-6">
    <div class="card">
      <div class="header-with-button">
        <h5>Contacts</h5>
        <div *hasPermission="['config.set']">
          <button
            *ngIf="!contactDetails.editMode"
            pButton
            icon="pi pi-pencil"
            (click)="
              contactDetails.editMode = true; onContactDetailsEditModeChange()
            "
          ></button>
          <button
            *ngIf="contactDetails.editMode"
            class="p-button-success"
            pButton
            icon="pi pi-save"
            (click)="saveInfo('additional-contact-details', contactDetails)"
          ></button>
        </div>
      </div>
      <p *ngFor="let item of contactDetails | keyvalue; trackBy: identify">
        <span *ngIf="item.key !== 'editMode'">
          <span *ngIf="configsLoaded; else elseBlock">
            {{ item.key | prettyProperty }}:
            <span
              *ngIf="!contactDetails.editMode"
              [class.placeholder-text]="!item.value"
              >{{ item.value | notSet }}</span
            >
            <span *ngIf="contactDetails.editMode"
              ><br /><input
                type="text"
                name="item.key"
                (change)="markAsModified(item.key)"
                [(ngModel)]="contactDetails[item.key]"
                pInputText
            /></span>
          </span>
        </span>
      </p>

      <div [formGroup]="notificationsForm">
        <h6 #leadWatchers>Lead Watchers</h6>
        <p>Receive notifications about all new leads.</p>
        <p-chips
          formControlName="leadWatchers"
          placeholder="Enter email or phone number then press enter"
          [max]="16"
          [addOnTab]="true"
          [addOnBlur]="true"
          (onAdd)="
            checkJobWatchers('leadWatchers');
            markAsModified('jobs.leadWatchers')
          "
          (onRemove)="markAsModified('jobs.leadWatchers')"
          (onClear)="markAsModified('jobs.leadWatchers')"
        ></p-chips>

        <p-divider></p-divider>

        <h6>Job Watchers</h6>
        <p>
          Receive notifications about all the events indicated below, including
          new leads.
          <br />
          <br />
          If no events specified per watcher, they will receive all events
          that are enabled by BCC configs.
        </p>

        <div formArrayName="jobWatchers" *ngIf="jobWatchers?.controls?.length > 0">
          <div
          *ngFor="let watcher of jobWatchers.controls; let i = index"
          [formGroupName]="i"
          class="watcher-chip"
        >
        <div class="watcher-email-container">
          <span>{{ watcher.get('email')?.value }}</span>
          <button
            type="button"
            pButton
            icon="pi pi-times"
            class="p-button-text p-button-sm"
            (click)="removeWatcher(i)"
          ></button>
        </div>

        <p-multiSelect
          formControlName="events"
          [options]="watcherEvents"
          optionLabel="label"
          optionValue="value"
          display="chip"
          (onChange)="markAsModified('jobs.watchers')"
        ></p-multiSelect>
        </div>
        </div>

        <br />
        <br />

        <input
          type="email"
          placeholder="Enter email and press Enter"
          (keydown.enter)="addWatcher($event)"
          pInputText
        />

        <br />
        <br />

        <p-divider></p-divider>

        <div *hasPermission="['config.set']">
          <br />
          <label>Notify watchers when document has been signed</label>
          <br />
          <p-inputSwitch
            formControlName="notifyWatchersDocumentCompleted"
          ></p-inputSwitch>

          <br />
          <label>Notify watchers when a document has been sent</label>
          <br />
          <p-inputSwitch
            formControlName="notifyWatchersDocumentSent"
          ></p-inputSwitch>

          <br />
          <label>Notify watchers when an SMS is received</label>
          <br />
          <p-inputSwitch
            formControlName="notifyWatchersSMSReceived"
          ></p-inputSwitch>

          <br />
          <label>Notify watchers when an Email is received</label>
          <br />
          <p-inputSwitch
            formControlName="notifyWatchersEmailReceived"
          ></p-inputSwitch>

          <br />
          <label
            >Notify watchers when there is an email error (bounce, spam report,
            or unsubscribe)</label
          >
          <br />
          <p-inputSwitch
            formControlName="notifyWatchersEmailError"
          ></p-inputSwitch>

          <br />
          <label>Notify job watchers of a new lead</label>
          <br />
          <p-inputSwitch
            formControlName="notifyWatchersNewLead"
          ></p-inputSwitch><br />
          <br />
          <br />
          <br />
          <label>BCC Job Watchers on all outgoing emails (control all subcategories below when on)</label>
          <br />
          <p-inputSwitch formControlName="notifyWatchersBCC"></p-inputSwitch>
          <br />
          <br />

          <div class="sub-switch">
            <label>BCC Job Watchers on rules based emails</label>
            <br />
            <p-inputSwitch formControlName="notifyWatchersBCCRulesEmails"></p-inputSwitch>
          </div>

          <div class="sub-switch">
            <label>BCC Job Watchers on emails sent manually</label>
            <br />
            <p-inputSwitch formControlName="notifyWatchersBCCManualEmails"></p-inputSwitch>
          </div>

          <div class="sub-switch">
            <label>BCC Job Watchers on emails sent by AI</label>
            <br />
            <p-inputSwitch formControlName="notifyWatchersBCCAIEmails"></p-inputSwitch>
          </div>

          <br />
          <label>Notify Job Watchers about escalation</label>
          <br />
          <p-inputSwitch formControlName="notifyWatchersScheduledCommunicationEscalation"></p-inputSwitch>
          <br />
          <br />

        </div>

        <h6>Lead Notification List (deprecated - for legacy purposes only)</h6>
        <app-user-search-multiple
          formControlName="leadNotificationRecipients"
        ></app-user-search-multiple>
      </div>
    </div>
  </div>
</div>
